import React from "react";
import { useDashboardValuePrivacy } from "../hooks/useDashboardValuePrivacy";

/**
 * Footer control to hide/show sensitive dashboard amounts
 * (yearly sales, revenue, due, bank balance).
 */
export default function FooterPrivacyEyeButton() {
  const { valuesHidden, toggleValuesHidden } = useDashboardValuePrivacy();

  return (
    <button
      type="button"
      className="btn btn-link nav-link p-0"
      onClick={toggleValuesHidden}
      title={valuesHidden ? "Show dashboard amounts" : "Hide dashboard amounts"}
      aria-label={
        valuesHidden ? "Show dashboard amounts" : "Hide dashboard amounts"
      }
      aria-pressed={valuesHidden}
      style={{
        textDecoration: "none",
        width: "22px",
        height: "22px",
        borderRadius: "50%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <iconify-icon
        className="footer-icon-strong"
        icon={valuesHidden ? "mdi:eye-off" : "mdi:eye"}
        style={{
          fontSize: "18px",
          filter:
            "drop-shadow(0 0 0 currentColor) drop-shadow(0 0 0 currentColor)",
        }}
      />
    </button>
  );
}
